import { createSlice } from "@reduxjs/toolkit";

interface ClientState {
  loading: boolean;
  isAuth: any;
  user: any;
  token: any;
  email: any;
  socials: any;
  priceAlerts: any;
  accountBalance: string;
}

const initialState: ClientState = {
  loading: false,
  isAuth: false,
  user: null,
  token: null,
  email: null,
  socials: null,
  priceAlerts: [],
  accountBalance: "0",
};

const clientSlice = createSlice({
  name: "client",
  initialState,
  reducers: {
    loading: (state) => {
      state.loading = true;
    },
    userJoin: (state, action) => {
      state.loading = false;
      state.email = action.payload.email;
    },
    userSocialJoin: (state, action) => {
      state.loading = false;
      state.user = action.payload.client;
      state.token = action.payload.token;
      state.isAuth = true;
      localStorage.setItem("svToken", action.payload.token);
      state.accountBalance = action.payload.accountBalance;
    },
    userverified: (state, action) => {
      state.loading = false;
      state.user = action.payload.client;
      state.token = action.payload.token;
      state.isAuth = true;
      localStorage.setItem("svToken", action.payload.token);
      state.accountBalance = action.payload.accountBalance;
    },
    userLoaded: (state, action) => {
      state.loading = false;
      state.isAuth = true;
      state.user = action.payload.user || action.payload.client || null;
      state.socials = action.payload.socials || [];
      state.accountBalance = action.payload.accountBalance || "0";
    },
    userUpdated: (state, action) => {
      state.loading = false;
      state.user = action.payload.result || state.user;
      state.accountBalance = action.payload.accountBalance || state.accountBalance;
    },
    logout: (state) => {
      state.loading = false;
      state.isAuth = false;
      state.user = null;
      state.token = null;
      state.email = null;
      state.socials = null;
      localStorage.removeItem("svToken");
    },
    priceAlertCreated: (state) => {
      state.loading = false;
    },
    priceAlertRemoved: (state) => {
      state.loading = false;
    },
    priceAlertLoaded: (state, action) => {
      state.loading = false;
      state.priceAlerts = action.payload;
    },
    failed: (state) => {
      state.loading = false;
    },
  },
});

export const {
  loading,
  userUpdated,
  userJoin,
  failed,
  userverified,
  userLoaded,
  userSocialJoin,
  priceAlertCreated,
  logout,
  priceAlertLoaded,
  priceAlertRemoved,
} = clientSlice.actions;

export default clientSlice.reducer;
